export type DocumentSharePickerState = {
  selectedGroups: Group[]
  selectedMembers: Member[]
  disabledGroups: Group[]
  disabledMembers: Member[]
  highlightedMember: Member | null
}

export const state: DocumentSharePickerState = {
  selectedGroups: [],
  selectedMembers: [],
  disabledGroups: [],
  disabledMembers: [],
  highlightedMember: null,
}
